import {useNavigate} from 'react-router-dom';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {CTABanner} from '../CTABannersCarousel';

const OLYMPICS_SCHOOL_NETWORK_ID = 116;

function useSocioEconomicalBanner({priority}: {priority: number}): CTABanner {
  const navigate = useNavigate();

  const {userRole, userProfile} = getUserData();

  const isOlympics =
    Number(userRole?.school_network_id) === OLYMPICS_SCHOOL_NETWORK_ID;

  return {
    priority,
    title: 'Pesquisa socioeconômica',
    theme: 'light',
    color: '#41c3ff',
    icon: ['fad', 'chart-simple'],
    description: 'Não se esqueça de responder nossa pesquisa socioeconômica!',
    isVisible: () =>
      !isOlympics &&
      userProfile?.answered_socioeconomical_questionnaire === false &&
      !sessionStorage.getItem('socialEconomicalReminderVisibility'),
    action: {
      text: 'Continuar atividade',
      onClick: () => {
        sessionStorage.setItem('socialEconomicalReminderVisibility', 'false');
        navigate('/atividades/pesquisa/334');
      },
    },
  };
}

export default useSocioEconomicalBanner;
